import gql from 'graphql-tag';

const EDIT_CHAT_MESSAGE = gql`
  mutation EditChatMessage($student_book_id: ID!, $message_id: ID!, $message: String!) {
    editChatMessage(student_book_id: $student_book_id, message_id: $message_id, message: $message) {
      id
      rows
    }
  }
`;

const DELETE_CHAT_MESSAGE = gql`
  mutation DeleteChatMessage($student_book_id: ID!, $message_id: ID!) {
    deleteChatMessage(student_book_id: $student_book_id, message_id: $message_id) {
      id
      rows
    }
  }
`;

const GET_CHAT_HISTORY = gql`
  query GetChatHistory($student_book_id: ID!) {
    getChatsHistory(student_book_id: $student_book_id) {
      student_book_id
      account_type
      service_id
      lesson_details {
        program_id
        program_name
        level_rank
        lesson_number
        lesson_title
        date_time
        student_nickname
        teacher_nickname
        faq_link
        result
      }
      messages {
        message_id
        date_time
        lesson_id
        student_id
        from
        message
        deleted
        deleted_message
        editted
      }
      events {
        event_id
        date_time
        lesson_id
        trainer_id
        student_id
        from
        event
      }
    }
  }
`;

const GET_CHAT_EDIT_HISTORY = gql`
  query GetChatsEditHistory($student_book_id: ID!, $message_id: ID!) {
    getChatsEditHistory(student_book_id: $student_book_id, message_id: $message_id) {
      message_id
      nickname
      message_history {
        edit_id
        message
        date_time
      }
    }
  }
`;

export {
  EDIT_CHAT_MESSAGE,
  DELETE_CHAT_MESSAGE,
  GET_CHAT_HISTORY,
  GET_CHAT_EDIT_HISTORY
};
